import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const commonParams =
  "/:pickupType/:pickupLocation/:pickupLabel/:pickupDate/:dropoffType/:dropoffLocation/:dropoffLabel/:dropoffDate/:pos/:cd/:pc/:hg/:couponCode";

const routes: Array<RouteConfig> = [
  {
    path: '/alquiler-autos-orlando',
    name: 'OrlandoLanding',
    component: () =>
      import( "../views/LandingPages/Orlando/OrlandoLanding.vue"),
  },
  {
    path: '/alquiler-autos-miami',
    name: 'MiamiLanding',
    component: () =>
      import(/* webpackChunkName: "listing" */ "../views/LandingPages/Miami/MiamiLanding.vue"),
  },
  {
    path: '/alquiler-de-autos-en-los-angeles',
    name: 'LosAngelesLanding',
    component: () =>
      import("../views/LandingPages/LosAngeles/LosAngelesLanding.vue"),
  },
  {
    path: '/alquiler-de-autos-en-new-york',
    name: 'NewYorkLanding',
    component: () =>
      import("../views/LandingPages/NewYork/NewYorkLanding.vue"),
  },
  {
    path: '/alquiler-de-autos-en-madrid',
    name: 'MadridLanding',
    component: () =>
      import("../views/LandingPages/Madrid/MadridLanding.vue"),
  },
  {
    path: '/alquiler-de-autos-en-barcelona',
    name: 'BarcelonaLanding',
    component: () =>
      import("../views/LandingPages/Barcelona/BarcelonaLanding.vue"),
  },
  {
    path: '/alquiler-de-autos-en-kansas-city-mundial',
    name: 'KansasCityLanding',
    component: () =>
      import("../views/LandingPages/KansasCity/KansasCityLanding.vue"),
  },
  {
    path: '/alquiler-de-autos-en-dallas-mundial',
    name: 'DallasLanding',
    component: () =>
      import("../views/LandingPages/Dallas/DallasLanding.vue"),
  },
  {
    path: '/alquiler-de-autos-en-houston',
    name: 'HoustonLanding',
    component: () =>
      import("../views/LandingPages/Houston/HoustonLanding.vue"),
  },
  {
    path: '/alquiler-de-autos-en-san-francisco',
    name: 'SanFranciscoLanding',
    component: () =>
      import("../views/LandingPages/SanFrancisco/SanFranciscoLanding.vue"),
  },
  {
    path: '/alquiler-de-autos-en-milan',
    name: 'MilanLanding',
    component: () =>
      import("../views/LandingPages/Milan/MilanLanding.vue"),
  },
  {
    path: '/alquiler-de-autos-en-roma',
    name: 'RomaLanding',
    component: () =>
      import("../views/LandingPages/Roma/RomaLanding.vue"),
  },
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "homepage" */ "../views/Home/Home.vue")
  },
  {
    path: `/cars${commonParams}`,
    name: "Listing",
    component: () =>
      import(/* webpackChunkName: "listing" */ "../views/Listing/Listing.vue")
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Contact/Contact.vue")
  },
  {
    path: `/checkout${commonParams}/:acriss/:rental/:rateQualifier/:aliasQualifier/:type/:country`,
    name: "Checkout",
    component: () =>
      import(
        /* webpackChunkName: "checkout" */ "../views/Checkout/Checkout.vue"
      )
  },
  {
    path: "/about-us",
    name: "About Us",
    component: () =>
      import(/* webpackChunkName: "aboutUs" */ "../views/AboutUs/AboutUs.vue")
  },
  {
    path: "/corporate",
    name: "Corporate",
    component: () =>
      import(/* webpackChunkName: "corporate" */ "../views/Corporate/Corporate.vue")
  },
  {
    path: "/agencies",
    name: "Agencies",
    component: () =>
      import(
        /* webpackChunkName: "agencies" */ "../views/Agencies/Agencies.vue"
      )
  },
  {
    path: "/login/:data",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "agencies" */ "../views/Login/Login.vue")
  },
  {
    path: "/fleet",
    name: "Fleet",
    component: () =>
      import(/* webpackChunkName: "agencies" */ "../views/Fleet/Fleet.vue")
  },
  {
    path: "/faq",
    name: "Faq",
    component: () =>
      import(/* webpackChunkName: "faq" */ "../views/Faq/Faq.vue")
  },
  {
    path: "/destiny",
    name: "Destiny",
    component: () =>
      import(
        /* webpackChunkName: "destiny" */ "../views/Destiny/Destiny.vue"
      )
  },
  {
    path: "/locations",
    name: "Locations",
    component: () =>
      import(
        /* webpackChunkName: "locations" */ "../views/Locations/Locations.vue"
      )
  },
  {
    path: "/promotions",
    name: "Promotions",
    component: () =>
      import(
        /* webpackChunkName: "promotions" */ "../views/Promotions/Promotions.vue"
      )
  },
  {
    path: "/promotions/:id",
    name: "PromotionsDetails",
    component: () =>
      import(
        /* webpackChunkName: "promotionsDetails" */ "../views/PromotionsDetails/PromotionsDetails.vue"
      )
  },
  {
    path: `/my-reservation/`,
    name: "MyReservation",
    component: () =>
      import(/* webpackChunkName: "listing" */ "../views/MyReservation/MyReservation.vue"),
  },

];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Si el navegador tiene una posición guardada (back/forward)
    if (savedPosition) {
      return savedPosition;
    }

    // Siempre ir arriba al cambiar de ruta
    return { x: 0, y: 0 };
  },
});

export default router;
